import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getYearsWithData, getCashOutRequestsByMonth } from "../../apis/revshare/ReportsApi";
import DataGrid from "../common/DataGrids/DataGrid";
import { Container, Form, FormControl, Row, Spinner } from "react-bootstrap";
import FormRow from "../common/forms/FormRow";
import SelectInput from "../common/forms/SelectInput";

const CashOutRequestByMonthReport = (props) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState();

  useEffect(() => {
    getYearsWithData()
      .then((years) => setYears(years))
      .catch((error) => {
        throw error;
      });
  }, []);

  return (
    <Container>
      <Row>
        <Form>
          <FormRow
            columns={[
              <SelectInput
                default={year.toString()}
                label="Year"
                onChange={(event) => setYear(event.target.value)}
                options={years}
              />,
            ]}
          />
        </Form>
      </Row>
      <Row>
        <CashOutRequestByMonthGrid isManger={props.isManger} year={year} />
      </Row>
    </Container>
  );
};

CashOutRequestByMonthReport.propTypes = {
  isManger: PropTypes.bool,
};

export default CashOutRequestByMonthReport;

const CashOutRequestByMonthGrid = (props) => {
  const headers = [
    { label: "Code", key: "code" },
    { label: "Employee ID", key: "employeeId" },
      { label: "Request Type", key: "requestType"},
    { label: "Paid Date", key: "paidDate" },
    { label: "Cash Requested", key: "cashRequested" },
    { label: "Hours Requested", key: "hoursRequested" },
  ];

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [monthFilter, setMonthFilter] = useState(0);
  const [months, setMonths] = useState([]);

  useEffect(() => {
    getCashOutRequestsByMonth(props.year, props.isManger)
      .then((data) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        throw error;
      });
  }, [props.year]);

  useEffect(() => {
    setMonths(
      data
        .filter((value, index, self) => self.findIndex((i) => value.month.number === i.month.number) === index)
        .map((i) => i.month)
    );
  }, [data]);

  useEffect(() => {
    if (monthFilter <= 0) setFilteredData(data);
    else {
      setFilteredData(data.filter((i) => i.month.number === monthFilter));
    }
  }, [monthFilter, data]);

  return (
    <>
      {loading ? <Spinner animation="border" /> : null}
      <Form>
        <FormControl as="select" onChange={(event) => setMonthFilter(parseInt(event.target.value))}>
          <option key={0} value={0}>
            All
          </option>
          {months.map((i) => (
            <option key={i.number} value={i.number}>
              {i.name}
            </option>
          ))}
        </FormControl>
      </Form>
      <DataGrid
        data={filteredData.map((i) => {
          return {
            code: "REVSH",
            employeeId: i.employeeId,
            requestType: i.requestType,
            paidDate: i.paidDate.replace(/\//g, "-"),
            hoursRequested: i.hoursRequested,
            cashRequested: i.cashRequested,
          };
        })}
        exportName="cashOutRequestByMonthReport"
        headers={headers}
      />
    </>
  );
};

CashOutRequestByMonthGrid.propTypes = {
  isManger: PropTypes.bool,
  year: PropTypes.number.isRequired,
};
